import { produce } from 'immer'
import { myWalletVirtualCardDetailRouteProps, virtualCardDetailRouteProps } from 'src/navigation/routeProps'
import {
  GET_VIRTUAL_CARD_FAILURE,
  GET_VIRTUAL_CARD_INIT,
  GET_VIRTUAL_CARD_SUCCESS,
  GetVirtualCardActions,
} from 'src/redux/actions/data/virtualCards.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'

export interface VirtualCardDetailBaseState {
  getVirtualCardSucceeded: boolean
  getVirtualCardFailed: boolean
}

export const initialBaseState: VirtualCardDetailBaseState = {
  getVirtualCardSucceeded: false,
  getVirtualCardFailed: false,
}

export type BaseActions = GetVirtualCardActions

const BaseVirtualCardDetailReducer = (
  state = initialBaseState,
  action: BaseActions,
): VirtualCardDetailBaseState => {
  // TODO: needs generic
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_VIRTUAL_CARD_INIT: {
        return draft
      }
      case GET_VIRTUAL_CARD_SUCCESS: {
        draft.getVirtualCardSucceeded = true
        return draft
      }
      case GET_VIRTUAL_CARD_FAILURE: {
        draft.getVirtualCardFailed = true
        return draft
      }
    }
  })
}

export type VirtualCardDetailState = VirtualCardDetailBaseState

export const initialState: VirtualCardDetailState = {
  ...initialBaseState,
}

export type Actions = BaseActions

const CoreVirtualCardDetailReducer = (
  state = initialState,
  action: Actions,
): VirtualCardDetailState => ({
  ...BaseVirtualCardDetailReducer(state, action as BaseActions),
})

const VirtualCardDetailReducer = createBackgroundReducer(
  [ myWalletVirtualCardDetailRouteProps, virtualCardDetailRouteProps ],
  initialState,
  CoreVirtualCardDetailReducer,
)

export default VirtualCardDetailReducer
